import * as React from "react";
import { useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import { contentSuffix, deliverySuffix, shareSuffix, styleSuffix } from "report/ReportRoutes";
import Delivery from "report/report-creation/Delivery";
import Overview from "./overview";
import Style from "./Style";
import Content from "./content";
import Share from "./Share";
const reportCreationRoutes = (editAllowed, isCreating = false) => [
  { path: "", component: /* @__PURE__ */ React.createElement(Overview, { editAllowed }) },
  { path: contentSuffix, component: /* @__PURE__ */ React.createElement(Content, { editAllowed }) },
  { path: deliverySuffix, component: /* @__PURE__ */ React.createElement(Delivery, { editAllowed }) },
  { path: styleSuffix, component: /* @__PURE__ */ React.createElement(Style, { editAllowed }) },
  ...isCreating ? [{ path: shareSuffix, component: /* @__PURE__ */ React.createElement(Share, null) }] : []
];
const ReportCreationRouter = ({ editAllowed, isCreating = false }) => {
  const routes = useMemo(
    () => reportCreationRoutes(editAllowed, isCreating).map(({ path, component }) => /* @__PURE__ */ React.createElement(Route, { key: path, path, element: component })),
    [editAllowed, isCreating]
  );
  return /* @__PURE__ */ React.createElement(Routes, null, routes);
};
export default ReportCreationRouter;
